import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import _ from "lodash"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"
// import { withPrefix } from "gatsby";
import { hyphenDelimitedLowerCase, titleCase } from "../utils/functions"
import { BASE_URL } from "../utils/constants"

export default function MerchantCarousel(props) {
  const lazyLoadImage = props.lazyLoadImage
  const enableProgressiveImageLoading = props.enableProgressiveImageLoading
  const data = [
    {
      merchantName: "Santan",
      imageURL: "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/santan.jpeg",
      link: "https://www.airasia.com/aa/restaurant-lists/santan-delivery/"
    },
    {
      merchantName: "Pizza Hut",
      imageURL: "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/PizzaHut.png",
      link: "https://www.airasia.com/aa/restaurant-lists/pizza-hut-delivery/"
    },
    {
      merchantName: "KFC",
      imageURL:"https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/kfc.jpg",
      link: "https://www.airasia.com/aa/restaurant-lists/kfc-delivery/"
    },
    {
      merchantName: "Tealive",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Tealive.png",
      link: "https://www.airasia.com/aa/restaurant-lists/tealive-delivery/" 
    },
    {
      merchantName: "A&W",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/A&W.jpg",
      link: "https://www.airasia.com/aa/restaurant-lists/anw-delivery/" 
    },
    {
      merchantName: "Sushi King",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/sushi-king.jpg",
      link: "https://www.airasia.com/aa/restaurant-lists/sushi-king-delivery/" 
    },
    {
      merchantName: "Marrybrown",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Marrybrown.png",
      link: "https://www.airasia.com/aa/restaurant-lists/marrybrown-delivery/" 
    },
    {
      merchantName: "Nando's",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/nandos.jpg",
      link: "https://www.airasia.com/aa/restaurant-lists/nandos-delivery/" 
    },
    {
      merchantName: "Sugar & i",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Sugar-I.png",
      link: "https://www.airasia.com/aa/restaurant-lists/sugar-i-delivery/" 
    },
    {
      merchantName: "Tommy Le Baker",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Tommy-Le-Baker.jpg",
      link: "https://www.airasia.com/aa/restaurant-lists/tommy-le-baker-delivery/"
    },
    {
      merchantName: "Sushi Hiro",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Sushi-Hiro.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/sushi-hiro-delivery/"
    },
    {
      merchantName: "The Chicken Rice Shop",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/The-Chicken-Rice-Shop.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/the-chicken-rice-shop-delivery/"
    },
    {
      merchantName: "Kubis & Kale",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/kubis-kale.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/kubis-kale-delivery/"
    },
    {
      merchantName: "TNR by Sean & Angie",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/tnr.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/tnr-delivery/"
    },
    {
      merchantName: "Eastern Wishes",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Eastern-Wishes.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/eastern-wishes-delivery/" 
    },
    {
      merchantName: "Xuan Feng",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Xuan-Feng.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/xuan-feng-delivery/" 
    },
    {
      merchantName: "Paradise Dynasty",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/paradise-dynasty.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/paradise-dynasty-delivery/"
    },
    {
      merchantName: "Para Thai",
      imageURL: "//www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/para-thai.jpg",
      link:"https://www.airasia.com/aa/restaurant-lists/para-thai-delivery/"
    },
    {
      merchantName: "QBistro",
      imageURL: "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Q_bistro.png",
      link: "https://www.airasia.com/aa/restaurant-lists/qbistro-delivery/"
    }]
  const carouselLabel = data
    .map(function (elem) {
      return elem
    })
    .join("|")
  const positionLabel = data
    .map(function (elem, index) {
      return index + 1
    })
    .join("|")
  // const tilePosition = props.numberOfCarousels ? props.numberOfCarousels + 1 : 1
  // const homepageURL = (props.homepageUrl === "/id/" || props.homepageUrl === "/th/" || props.homepageUrl === "/sg/")?"/":props.homepageUrl
  const cardData = data.map((merchant, index) => {
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: "",
      currencyCode: "",
      discount: "",
      hidden: "",
      image:
      merchant.imageURL,
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: "",
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: "",
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: "",
      timer: "",
      title: merchant.merchantName,
      url: merchant.link
    }
  })

  const gtmUserType = getGtmUserType()

  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true,
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: `${GTM_PROJECT_CATEGORY}|carousel|MerchantInternalLink`,//|${tilePosition}`,
          eventLabelCardClick: `${GTM_PROJECT_CATEGORY}|{{cardtitle}}|{{cardposition}}`,
          eventLabelHeadlineClick: `${gtmUserType}|headline|{{headline}}`,
          eventLabelView: `${carouselLabel}|${positionLabel}`,
          // eventLabelView: `${GTM_PROJECT_CATEGORY}|${gtmUserType}`
        },
        headline: "",
        headlineStyle: "h2",
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Merchant Widget",
        widgetWidth: "3",
      }}
      // gtmConsumerName={props.gtmConsumerName}
      fireGtm={obj => {
        fireGtmEvent(obj)
        // if(!tilePosition)fireGtmEvent(obj)
      }}
      isLoading={false}
      isHideFooter={true}
      handleClick={function noRefCheck() {}}
      templateType="productCard"
      theme="AIRASIA_CLASSIC"
      lazyLoadImage={lazyLoadImage}
      enableProgressiveImageLoading={enableProgressiveImageLoading}
    />
  )
}
